import browserFingerprint from './browserFingerprint.js'
import realLiveLogo from '../../static/img/realLiveLogo.png'
import buzzCastLogo from '../../static/img/logo180x180.png'
import bondoLogo from '../../static/img/bondoLogo.png'
import i18n from '../i18n'

// 取值函数
export  function get(obj, keys, defalutValue){
    if(typeof keys !== 'string') throw Error('get 函数调用失败');
    const keysArr = keys.split('.');
    let val = obj;

    for(let k of keysArr) {
        console.log(val)
        if(!val) return defalutValue;
        val = val[k];
    }

    return val;

}

/**
 * 国家的本地货币符号
 * @type
 */
const countryMoneySymbol = {
    'CN': '￥',
    'EG': '£',
    'RU': '₽',
    'US': '$'
}

/**
 * 获取国家的本地货币符号，默认美元
 * @param country
 * @returns {string}
 */
export function getMoneySymbol(country) {
  console.log("country==>",country)
    if(!country) {
        return countryMoneySymbol['US']
    }
    let str= countryMoneySymbol[country]
    if(!str) {
        return countryMoneySymbol['US']
    }
    return str
}

// 检查是否在 Telegram WebApp 环境中
export function isTelegramWebApp(route) {
  // 使用window获取当前链接，判断链接中是都含有'code=telegram'字符串，判断是否为telegram
  const currentUrl = window.location.href;
  const isTg = currentUrl.includes('code=telegram');
  // 获取链接参数code的值，判断是否为telegram
  if (route.query.code == 'telegram' || isTg) {
    return true;
  }
  return false;
}

/**
 * 计算浏览器指纹
 * 优先从localStorage读取缓存，如果没有则生成新指纹并缓存
 * @returns {Object} 指纹结果
 */
export function getBrowserFingerprint() {
  const STORAGE_KEY = 'browser_fingerprint';
  try {

    // 尝试从localStorage读取缓存
    const cachedFingerprint = localStorage.getItem(STORAGE_KEY);
    if (cachedFingerprint) {
      const parsedResult = JSON.parse(cachedFingerprint);
      return parsedResult;
    }

    // 如果没有缓存，生成新指纹
    const fingerprintInstance = browserFingerprint;
    const result = fingerprintInstance.getFingerprint();

    // 将新指纹存入localStorage
    localStorage.setItem(STORAGE_KEY, JSON.stringify(result));

    return result;
  } catch (err) {
    throw err;
  }
}

/**
 * 提取参数
 * @param url 链接地址
 * @param keyName 需要排除的参数名
 * @returns {string}
 */
export function extractParamsExcluding(url, keyName) {
  let result = extractObjParamsExcluding(url, keyName)
  return objectToQueryString(result);
}

export function extractObjParamsExcluding(url, keyName) {
  // 提取查询参数部分（忽略哈希部分）
  let queryStringArr = url.split('?')
  if(!queryStringArr || queryStringArr.length < 2) {
    return ''
  }
  let queryString = url.split('?')[1]
  if(queryString) {
    queryString = queryString.split('#')[0] || ''
  }
  const params = queryString.split('&');
  const result = {};

  // 遍历所有参数，排除 指定 参数
  for (const param of params) {
    const [key, value] = param.split('=');
    if (key && key !== keyName) {
      result[key] = decodeURIComponent(value || '');
    }
  }
  return result
}

export function objectToQueryString(params) {
  return Object.entries(params)
    .map(([key, value]) => `${key}=${value}`)
    .join('&');
}

export const REALlIVE_APP = 'RealLive'
export const BONDO_APP = 'Bondo'
export const BUZZCAST_APP = 'BuzzCast'
export const LOCALHOST = 'localhost:8089'

const buzzCastHosts = [process.env.buzzcast_host, process.env.buzzcast_host_ph]
const otherAppNames = [REALlIVE_APP, BONDO_APP]

// 本地测试bondo/reallive时，1.将下面代码解开  2.getAppName 函数中返回指定的appName
// otherAppNames.push(LOCALHOST)

/**
 * 根据域名获取当前的app名称
 * @returns {string}
 */
export function getAppName() {
  let host = window.location.host
  console.log("getAppName-->", host)
  if(host === process.env.reallive_host) {
    return REALlIVE_APP
  }
  if(host === process.env.bondo_host) {
    return BONDO_APP
  }
  if(buzzCastHosts.includes(host)) {
    return BUZZCAST_APP
  }
  return BUZZCAST_APP
  // return REALlIVE_APP
  // return BONDO_APP
}
const appName = getAppName()
export function isNotBuzzCast() {
  console.log('appName => ', appName)
  return otherAppNames.includes(appName)
}

export function isBondo() {
  return appName === BONDO_APP
}

export function isRealLive() {
  return appName === REALlIVE_APP
}

/**
 * 获取域名对应的字段值,需要传到后端
 * @returns {string}
 */
export function getDomainCountryFiled() {
  const host = window.location.host
  if(host === process.env.reallive_host) {
    return REALlIVE_APP
  }
  if(host === process.env.bondo_host) {
    return BONDO_APP
  }
  if(host === process.env.buzzcast_host_ph) {
    return 'PH'
  }
  return null
}

/**
 * 设置网站的logo和标题
 */
export function setLogoAndTitle() {
  let logoEle = document.getElementById('web-logo');
  let appleLogoEle = document.getElementById('web-apple-logo');
  if(appName === REALlIVE_APP) {
    logoEle.href = realLiveLogo
    appleLogoEle.href = realLiveLogo
  } else if(appName === BUZZCAST_APP) {
    logoEle.href = buzzCastLogo
    appleLogoEle.href = buzzCastLogo
  } else if(appName === BONDO_APP) {
    logoEle.href = bondoLogo
    appleLogoEle.href = bondoLogo
  }
  document.title = i18n.t('m.Diamonds_title', { msg: appName });
}




// WEBPACK FOOTER //
// ./src/util/index.js